import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fmtDateTime } from "../lib/api";
import { StatusPill } from "../components/Primitives";

export default function WIP() {
  const [jcs, setJcs] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/job-cards", { params: { status: "in_progress" } }).then(({ data }) => setJcs(data));
  }, []);

  return (
    <div>
      <div className="kk-overline mb-1">04 · 03</div>
      <h2 className="font-display text-2xl uppercase mb-5">Work in Progress</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {jcs.map((j) => (
          <div key={j.id} onClick={() => nav(`/service/jobcards/${j.id}`)}
               className="kk-card p-5 cursor-pointer" data-testid={`wip-card-${j.id}`}>
            <div className="flex items-center justify-between">
              <div className="font-mono text-xs">{j.code}</div>
              <StatusPill status={j.status} />
            </div>
            <div className="font-display text-lg mt-2 uppercase">{j.make} {j.model}</div>
            <div className="text-xs text-[var(--kk-muted)]">{j.customer_name} · {j.registration_no}</div>
            <div className="mt-3 text-[0.7rem] uppercase tracking-wider">
              Parts issued: <span className="font-mono">{(j.issued_items || []).length}</span> · Logs: <span className="font-mono">{(j.work_logs || []).length}</span>
            </div>
            <div className="text-[0.7rem] font-mono text-[var(--kk-muted)] mt-1">Started {fmtDateTime(j.advance_paid_at || j.created_at)}</div>
          </div>
        ))}
        {jcs.length === 0 && <div className="text-sm text-[var(--kk-muted)]">No jobs currently in progress.</div>}
      </div>
    </div>
  );
}
